/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { showSwitchAtom, selectedVersionAtom, isChangedAtom, mobileAtom } from '../Atoms';

const VersionStepper = function VersionStepper({ numberVersions, allVersionsData }) {
  const setShowSwitch = useSetRecoilState(showSwitchAtom);
  const setSelectedVersion = useSetRecoilState(selectedVersionAtom);
  const [isChanged, setIsChanged] = useRecoilState(isChangedAtom);
  const [markers, setMarkers] = useState([]);
  const mobile = useRecoilValue(mobileAtom);
  const [stepsNumber, setStepsNumber] = useState(mobile ? 3 : 7);
  const [activeStep, setActiveStep] = useState(numberVersions >= stepsNumber ? 6 : numberVersions);
  const [mobileStep, setMobileStep] = useState(0);

  const createMakers = () => {
    const tmpMarkers = [];
    for (let i = 0; i <= numberVersions; i++) {
      tmpMarkers.push({ label: `V${i}`, value: i });
    }
    setMarkers([...tmpMarkers]);
    setActiveStep(tmpMarkers.length >= stepsNumber ? 6 : tmpMarkers.length - 1);
    setMobileStep(Math.ceil(tmpMarkers.length / stepsNumber) - 1);
  };

  useEffect(() => {
    if (mobile) setStepsNumber(3);
    else setStepsNumber(7);
  }, [mobile]);
  useEffect(() => {
    createMakers();
  }, []);

  useEffect(() => {
    if (isChanged) {
      createMakers();
      setIsChanged(false); //set isChanged to false to check changes next times
    }
  }, [isChanged]);

  function createStepper() {
    const cont = Math.ceil(markers.length / stepsNumber);
    let marks = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= cont; i++) {
      if (i - 1 === mobileStep) {
        if (i === cont) {
          marks = markers.slice(-stepsNumber);
        } else {
          marks = markers.slice((i - 1) * stepsNumber, i * stepsNumber);
        }
      }
    }
    return marks;
  }
  let versions = [];

  const handleStep = (i) => {
    setActiveStep(i);
    setSelectedVersion(i);
  };

  const handleNext = () => {
    if (mobileStep < Math.ceil(markers.length / stepsNumber)) {
      setMobileStep((prevActiveStep) => prevActiveStep + 1);
      setActiveStep(-1);
    }
  };

  const handleBack = () => {
    if (mobileStep > -1) {
      setMobileStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  versions = createStepper();
  useEffect(() => {
    if (activeStep === versions.length - 1 && versions[activeStep].value == markers.at(-1).value) {
      setShowSwitch(true);
    } else setShowSwitch(false);
  }, [versions]);

  return (
    <Box
      mt={5}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stepper activeStep={activeStep} alternativeLabel nonLinear>
        {versions.map((version, index) => {
          const versionDate = new Date(allVersionsData[index]?.dataInizioValidita);
          const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
          return (
            <Step key={version.value}>
              <StepLabel>
                <Button
                  onClick={() => {
                    handleStep(index);
                  }}
                  sx={{ width: '30%' }}
                >
                  {`${version.label}\n${versionDate.toLocaleDateString(undefined, options)}`}
                </Button>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <MobileStepper
        style={{ position: 'relative', backgroundColor: '#ece7e7' }}
        variant="dots"
        steps={Math.ceil(markers.length / 7)}
        activeStep={mobileStep}
        nextButton={
          <IconButton
            size="large"
            onClick={handleNext}
            disabled={mobileStep === Math.ceil(markers.length / stepsNumber) - 1}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        }
        backButton={
          <IconButton size="large" onClick={handleBack} disabled={mobileStep === 0}>
            <ArrowBackIosNewIcon />
          </IconButton>
        }
      />
    </Box>
  );
};

export default VersionStepper;
